module.exports = __webpack_public_path__ + "img/fig03.36152b7f.jpg";